// extracted by mini-css-extract-plugin
export default {"Container":"SectionList_Container__mkaXy"};